<template>
    <div class="vehicle-entry-form">
        <div class="alert alert-warning" v-if="!vehicleInside">
            No es posible realizar este ingreso, este vehículo ya se encuentra
            dentro de las instalaciones
            <div class="col-12 text-right">
                <hr />
                <button
                    class="btn btn-secondary"
                    @click="$bus.$emit('entry.reset')"
                >
                    <i class="fa fa-times"></i> Volver
                </button>
            </div>
        </div>
        <div class="row" v-if="vehicleInside">
            <!-- Izquierda -->
            <div class="col-12 col-sm-10 m-sm-auto">
                <div class="card">
                    <div class="card-body">
                        <app-sub-title text="Datos Adicionales" />
                        <div class="card-text">
                            <div class="row">
                                <div class="col-12 col-sm">
                                    <app-form-text-input
                                        label="Placa"
                                        :value="document.toUpperCase()"
                                        :disabled="true"
                                    />
                                    <app-form-select-input
                                        label="Tipo de vehículo"
                                        :disabled="!vehicleTypes.length"
                                        @change="
                                            $v.entry.vehicleTypeId.$touch()
                                        "
                                        :options="vehicleTypes"
                                        v-model="entry.vehicleTypeId"
                                        :required="true"
                                        :has-error="
                                            $v.entry.vehicleTypeId.$error
                                        "
                                        error-message="Debe seleccionar el tipo de vehículo"
                                    />
                                    <app-form-text-input
                                        label="Marca"
                                        v-model="entry.brand"
                                    />
                                </div>
                                <div class="col-12 col-sm">
                                    <app-form-select-input
                                        v-if="!isInternal"
                                        label="Tipo de Visitante"
                                        :disabled="!vehicleEntryTypes.length"
                                        :options="vehicleEntryTypes"
                                        v-model="entry.visitorTypeId"
                                        :required="true"
                                        :hasError="
                                            $v.entry.visitorTypeId.$error
                                        "
                                        @change="
                                            $v.entry.visitorTypeId.$touch()
                                        "
                                        error-message="Escoja el tipo de visitante"
                                    />
                                    <app-autocomplete
                                        v-if="!isInternal"
                                        label="Destino"
                                        :items="destinations"
                                        label-prop="destination"
                                        id="destination"
                                        :required="true"
                                        v-model="destination"
                                        :hasError="
                                            $v.entry.destinationId.$error
                                        "
                                        @input="$v.entry.destinationId.$touch()"
                                        error-message="Seleccione el destino"
                                    />
                                    <span
                                        v-if="
                                            !isInternal &&
                                                $v.entry.destinationId.$error
                                        "
                                        class="field-error"
                                        >Debe especificar el destino</span
                                    >
                                    <!-- <app-form-text-input
                                        v-if="!isInternal"
                                        label="Motivo"
                                        v-model="entry.purpose"
                                    /> -->
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6 m-sm-auto">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="card-text">
                                                <button
                                                    class="btn btn-primary btn-block"
                                                    @click="startSelectPhotos()"
                                                >
                                                    <i class="fa fa-camera"></i>
                                                    Agregar Fotos
                                                </button>
                                                <div v-if="files">
                                                    <label for>
                                                        {{
                                                            files.photos.length
                                                        }}
                                                        Fotos seleccionadas
                                                    </label>
                                                    <br />
                                                    <label for>
                                                        {{ files.files.length }}
                                                        Archivos seleccionados
                                                    </label>
                                                    <button
                                                        class="btn btn-sm btn-danger pull-right"
                                                        @click="
                                                            cancelFilesSelected
                                                        "
                                                    >
                                                        <i
                                                            class="fa fa-trash-o"
                                                            aria-hidden="true"
                                                        ></i>
                                                        Cancelar archivos
                                                        seleccionados
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div class="row">
                                <div class="col-12 m-sm-auto">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="card-title">
                                                <h4>Pasajeros</h4>
                                            </div>
                                            <div class="card-text">
                                                <app-passengers
                                                    v-model="passengers"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div class="row" v-if="!isInternal">
                                <div class="col-12">
                                    <app-autocomplete
                                        id="approvedVehicleEntry"
                                        :items="destinationPeople"
                                        label="Persona que autoriza ingreso"
                                        label-prop="destination"
                                        v-model="approvedByObject"
                                        :required="true"
                                        :has-error="$v.approvedByObject.$error"
                                        error-message="Debe especificar quien autoriza ingreso"
                                    ></app-autocomplete>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <label for="notesPrevious"
                                        >Notas previas</label
                                    >
                                    <app-form-textarea-input
                                        :readonly="true"
                                        id="notesPrevious"
                                        v-model="previousNotes"
                                    />
                                </div>
                                <div class="col-6">
                                    <app-form-textarea-input
                                        label="Nuevas notas"
                                        v-model="entry.notes"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="vehicleInside">
            <div class="col-12 col-sm-10 col-lg-8 m-sm-auto text-right">
                <hr />
                <button
                    class="btn btn-secondary"
                    @click="$bus.$emit('entry.reset')"
                >
                    <i class="fa fa-times"></i> Volver
                </button>
                <button
                    class="btn btn-confirm"
                    ref="btnregister"
                    @click="register"
                    :disabled="inProgress"
                >
                    <i class="fa fa-save"></i> Registrar Ingreso de vehículo
                </button>
            </div>
        </div>
        <app-pop-up
            title="Fotos de vehiculo"
            id="vehicle-entries-photos-popup"
            size="large"
        >
            <div class="body" slot="body">
                <app-upload-or-take-photo
                    id="vehicle-entry-photos"
                    title="Fotos de vehículo"
                    v-model="files"
                />
            </div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="acceptFiles">
                    <i class="fa fa-floppy-o" aria-hidden="true"></i> Guardar
                    Fotos
                </button>
            </div>
        </app-pop-up>
    </div>
</template>
<script>
import FormTextInput from '../../../../UI/Controls/Forms/FormTextInput.vue'
import FormSelectInput from '../../../../UI/Controls/Forms/FormSelectInput.vue'
import FormTextareaInput from '../../../../UI/Controls/Forms/FormTextareaInput.vue'
import Autocomplete from '../../../../UI/Controls/AutocompleteV3/Autocomplete.vue'
import UploadOrTakePhoto from '../../../../UI/Controls/Photos/UploadOrTakePhoto'
import PopUp from '../../../../UI/Controls/PopUp/PopUp.vue'
import vigilanceRepository from '../../../../../repositories/vigilance.repository'
import vehiclesRepository from '../../../../../repositories/vehicles.repository'
import { required } from 'vuelidate/lib/validators'
import Passengers from './Passengers/Passengers.vue'
import { mapGetters } from 'vuex'
import repo from '../../../../../repositories/repo'

export default {
    components: {
        appFormTextInput: FormTextInput,
        appFormSelectInput: FormSelectInput,
        appFormTextareaInput: FormTextareaInput,
        appAutocomplete: Autocomplete,
        appPassengers: Passengers,
        appUploadOrTakePhoto: UploadOrTakePhoto,
        appPopUp: PopUp,
    },
    props: {
        document: {
            required: true,
        },
    },
    data() {
        return {
            entry: {
                vehicleTypeId: '',
                brand: '',
                visitorTypeId: '',
                notes: '',
                destinationId: '', // Destination
                purpose: '',
                visitedPersonId: '',
                internal: false,
                approvedById: '',
            },
            previousNotes: '',
            passengers: [],
            destination: '',
            approvedByObject: '',
            // vehicleEntryTypes: [],
            // vehicleTypes: [],
            files: '',
            vehicleInside: true,
            destinations: [],
        }
    },
    validations() {
        let entry = {}
        let approvedByObject = {}
        if (this.isInternal) {
            entry = {
                vehicleTypeId: {},
                visitorTypeId: {},
                destinationId: {},
            }
        } else {
            entry = {
                vehicleTypeId: { required },
                visitorTypeId: { required },
                destinationId: { required },
            }
            approvedByObject = { required }
        }
        return { entry, approvedByObject }
    },
    watch: {
        destination(val) {
            if (!val) return
            this.entry.destinationId = val.structure_id
            this.entry.visitedPersonId = !!val.person_id ? val.person_id : ''

            this.approvedByObject = !!val.person_id ? val : ''
            this.approvedById = !!val.person_id ? val.person_id : ''

            // if (val) {
            //     if (!!val.structure_type) {
            //         this.entry.destinationId = val.id
            //         this.entry.visitedPersonId = ''
            //     } else {
            //         this.entry.destinationId = val.structure_id
            //         this.entry.visitedPersonId = val.id
            //     }
            // }
        },

        approvedByObject(val) {
            if (!val) return
            this.approvedByObject = val
            this.entry.approvedById = val.person_id
            // if (val.id == 0) {
            //     toastr.error('No existe esta persona')
            //     this.entry.approvedById = ''
            //     this.approvedByObject = ''
            //     this.$bus.$emit('approvedVehicleEntry.reset')
            // } else {
            //     this.entry.approvedById = val.id
            // }
        },
    },
    methods: {
        searchPlate() {
            if (this.document.length === 0) return

            const vr = Object.assign({}, vigilanceRepository)

            vr.searchPlate(this.document, this.client.id)
                .then(data => {
                    if (!data) return

                    //Saber si la persona ya esta dentro de las instalaciones
                    if (data.isInside) {
                        this.vehicleInside = false
                        return
                    }

                    // Si existe el vehiculo setea las caracteristicas internas
                    if (!data.vehicle) return

                    this.entry.internal = data.vehicle.internal
                    this.entry.vehicleTypeId = data.vehicle.vehicle_type_id
                    this.entry.brand = data.vehicle.brand
                    this.$nextTick(() => {
                        this.$refs.btnregister.focus()
                    })
                    // Notas de ingresos previos
                    this.previousNotes = data.vehicle.vehicle_entries
                        .filter(item => !!item.notes)
                        .map(item => item.notes)
                        .join('\n' + '-')

                    const { lastEntry, lastDriver } = data
                    // Si se encontro información de un usuario y es interno habilita el boton de ingreso para agilizar el proceso
                    // de registro

                    // Se inhabilita la carga automatica de pasajeros por protocolo donde deben registrar la temperatura
                    if (lastEntry) {
                        this.entry.visitedPersonId = lastEntry.visited_person_id
                            ? lastEntry.visited_person_id
                            : ''
                        this.entry.destinationId = lastEntry.destination_id
                        this.entry.visitorTypeId =
                            lastEntry.vehicle_entry_type_id
                        this.destination = !!lastEntry.visited_person
                            ? lastEntry.visited_person
                            : lastEntry.destination
                    }

                    if (false && lastDriver) {
                        const phone =
                            !!lastDriver.person &&
                            lastDriver.person.phone &&
                            lastDriver.person.phone !== 'null'
                                ? lastDriver.person.phone
                                : ''
                        const passenger = {
                            document: lastDriver.person.document,
                            name: lastDriver.person.name,
                            phone: phone,
                            passengerTypeId: lastDriver.visitor_type_id,
                        }
                        !!lastDriver.person.arl &&
                            (passenger['arl'] = lastDriver.person.arl)

                        this.passengers = [passenger]
                    }
                })
                .catch(error => {
                    toastr.error(
                        'Ocurrió un error al consultar la placa del vehículo'
                    )
                })
        },
        register() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }
            // TODO: Validar si los pasajeros son obligatorios o no
            // if(this.passengers.length === 0){
            //     toastr.error('Ingrese los pasajeros del vehiculo');
            // }

            const formData = new FormData()
            Object.keys(this.entry).map(key =>
                formData.append(key, !!this.entry[key] ? this.entry[key] : '')
            )
            formData.set('internal', this.entry.internal)
            formData.append('plate', this.document)
            formData.append('clientId', this.client.id)
            formData.append('userId', this.user.id)
            formData.append('structureId', this.accessPoint.id)
            formData.append('destinationId', this.entry.destinationId)
            formData.append('approvedById', this.entry.approvedById)

            this.passengers.map((item, index) => {
                formData.append(
                    `passengers[${index}][temperature]`,
                    item.temperature ?? 0
                )
                formData.append(`passengers[${index}][document]`, item.document)
                formData.append(`passengers[${index}][name]`, item.name)
                formData.append(`passengers[${index}][phone]`, item.phone)
                formData.append(
                    `passengers[${index}][passengerTypeId]`,
                    item.passengerTypeId
                )
                !!item.arl &&
                    !!item.arl.id &&
                    formData.append(`passengers[${index}][arlId]`, item.arl.id)
            })
            if (this.files.photos) {
                this.files.photos.map(item => formData.append('photos[]', item))
            }
            if (this.files.files) {
                this.files.files.map((item, index) =>
                    formData.append('file' + index, item)
                )
            }

            formData.append('shiftId', this.$store.getters.shift.id)

            const vr = Object.assign({}, vehiclesRepository)
            vr.registerEntry(formData)
                .then(data => {
                    Object.keys(this.entry).map(key => (this.entry[key] = ''))
                    this.passengers = []
                    this.$bus.$emit('destination.reset')
                    this.$bus.$emit('entry.reset')

                    // const vehicleEntries = this.$store.getters.vehicleEntries.slice(0);
                    // vehicleEntries.push(data);
                    // this.$store.commit('vehicleEntries', vehicleEntries);
                    // this.$store.dispatch("entries");

                    toastr.success('Vehículo registrado satisfactoriamente')
                })
                .catch(error => {
                    toastr.error(
                        'Ocurrió un error al registrar el ingreso de vehiculo'
                    )
                })
        },
        startSelectPhotos() {
            this.$bus.$emit('vehicle-entries-photos-popup.open')
        },
        cancelFilesSelected() {
            this.$bus.$emit('vehicle-entry-photos.clean')
            this.files = ''
            this.$bus.$emit('vehicle-entries-photos-popup.close')
            toastr.success('Archivos cancelados')
        },
        acceptFiles() {
            this.$bus.$emit('vehicle-entries-photos-popup.close')
            toastr.success('Fotos seleccionadas')
        },
        cameraOff() {
            this.$bus.$emit('vehicle-entry-photos.camera-off')
        },
        async loadDestinations() {
            const { data } = await repo.get(
                `venues/${this.accessPoint.venue_id}/destinations`
            )
            this.destinations = data
        },
    },
    computed: {
        ...mapGetters(['vehicleTypes', 'vehicleEntryTypes', 'arls']),
        isInternal() {
            return !!this.entry.internal
        },
        destinationPeople() {
            return this.destinations.filter(
                destination =>
                    destination.type === 'person' &&
                    destination.structure_id === this.destination.structure_id
            )
        },
    },
    mounted() {
        this.searchPlate()
    },
    created() {
        // this.loadMasterData();
        this.load('vehicleEntryMasterData')
        this.load('passengerTypes')
        this.load('arls')
        this.$bus.$on('searchDocument', this.searchPlate)
        this.loadDestinations()
    },
}
</script>
